import axios from 'axios'
import { Message } from 'element-ui'
import cuda from '@/utils/checkCuda'

// cuda1 的固定地址（视频生成和视频反推专用）
const CUDA1_URL = 'https://uu680646-erl9-dd9fb7e3.westd.seetacloud.com:8443'

let lastUsedBaseUrl = ''
const currentCudaIndex = 'cuda1' // 固定使用 cuda1

export const getLastUsedBaseUrl = () => {
  return lastUsedBaseUrl
}

// 返回cuda对应的编号
export const cudaIndexNum = () => {
  return currentCudaIndex
}

// ComfyUI后台服务 - 视频专用（固定使用 cuda1）
const request = axios.create({
  baseURL: '',
  timeout: 5000,
  headers: {
    'Content-Type': 'application/json'
  }
})

// 添加请求拦截器
request.interceptors.request.use(async function (config) {
  try {
    // 直接将 cuda1 状态设置为 running
    await cuda.changeCudaCurrentStatus('cuda1', 'running')
    // 固定使用 cuda1 的地址
    config.baseURL = CUDA1_URL
    lastUsedBaseUrl = config.baseURL
    console.log(`📡 [视频专用] 配置完成，baseURL: ${config.baseURL} (固定使用 cuda1)`)
  } catch (error) {
    console.error('🚨 [视频专用] 设置 cuda1 状态失败:', error)
    // 即使设置状态失败，仍然使用 cuda1 地址
    config.baseURL = CUDA1_URL
    lastUsedBaseUrl = config.baseURL
  }

  // 设置超时时间
  config.timeout = 10000 // 增加到10秒

  return config
}, function (error) {
  // 对请求错误做些什么
  console.error('🚨 [视频专用] 请求拦截器错误:', error)
  return Promise.reject(error)
})

//  添加响应拦截器
request.interceptors.response.use(response => {
  if (response.status && response.status !== 200) {
    console.error('response', response)
    throw new Error('服务错误')
  }

  return response.data
}, async error => {
  // 详细的错误信息输出
  console.error('💱 [视频专用] 完整错误信息:', {
    message: error.message,
    code: error.code,
    response: error.response?.status,
    hasResponse: !!error.response,
    baseURL: error.config?.baseURL,
    url: error.config?.url
  })
  const { response } = error
  if (response && response.status >= 400) {
    console.error('⚠️ [视频专用] 服务器错误:', response.status)
    console.error('📝 [视频专用] 错误响应数据:', JSON.stringify(response.data, null, 2))
    console.error('📝 [视频专用] 错误详情:', response.data)
    await cuda.changeCudaCurrentStatus(currentCudaIndex, 'leisure')
    Message.error(`🚨 服务器不可用(HTTP ${response.status})\n请检查ComfyUI是否正常运行`)
  } else if (error.code === 'ENOTFOUND' || error.code === 'ECONNREFUSED' || error.code === 'ECONNABORTED') {
    console.error(`🛑 [视频专用] 无法连接ComfyUI服务器(${lastUsedBaseUrl})\n错误代码: ${error.code}`)
    Message.error(`🛑 无法连接ComfyUI服务器
URL: ${lastUsedBaseUrl}
错误: ${error.code}

请检查:
1. ComfyUI业务是否在线
2. 云端事例是否正常运行
3. 网络連接是否正常`)
  } else if (!window.navigator.onLine) {
    console.error('🛑 [视频专用] 你的本地网络已断开')
    await cuda.changeCudaCurrentStatus(currentCudaIndex, 'leisure')
    Message.error('🛑 网络已断开，请检查你的网络连接')
  } else {
    console.error('🛑 [视频专用] 未知的网络错误:', error.message)
    Message.error(`🛑 网络错误: ${error.message}\n请查看浏览器控制台了解触情`)
  }
  return Promise.reject(error)
})

export default request
